import { useTemplateEditorStore } from "../../../../store/useTemplateEditorStore";
import { useTemplatesStatusStore } from "../../../../store/useTemplatesStatusStore";
import { getBackgroundStyle } from "../../../../helpers/itemsHelper";
import { useTemplateData } from "../../../../hooks/useTemplateData";
import { ITEM_TYPES, TabKeys } from "../../../../types";
import type { GradientDefinition } from "types";

export const ColoredBackground = ({
  width,
  height,
  backgroundColor,
  disableOnclick = false,
}: {
  width: number;
  height: number;
  backgroundColor?: string | GradientDefinition;
  disableOnclick?: boolean;
}) => {
  const {
    brandKitData: { brandKitPalette },
  } = useTemplateData();

  const setCurrentItem = useTemplateEditorStore(
    (store) => store.setCurrentItem
  );
  const setActiveTab = useTemplatesStatusStore((store) => store.setActiveTab);

  const selectBackground = () => {
    setCurrentItem({ type: ITEM_TYPES.Background });
    setActiveTab(TabKeys.objects);
  };

  if (!backgroundColor && disableOnclick) return null;

  return (
    <div
      style={{
        width,
        height,
        ...(backgroundColor
          ? getBackgroundStyle(backgroundColor, brandKitPalette)
          : {}),
        position: "absolute",
        top: 0,
        left: 0,
      }}
      onClick={() => {
        if (disableOnclick) return;
        selectBackground();
      }}
    />
  );
};
